import React, {ReactNode} from "react";
import {Container} from "@bounce/shared/ui";
import {SxProps, Theme} from "@mui/material";

interface AuthPageContainerProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const AuthPageContainer = ({children, sx}: AuthPageContainerProps) => {
  return (
    <Container
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "84px 24px",
        background: "linear-gradient(180deg, #FDFBF8 73.53%, #F9E2E2 86.76%, #EDB4B9 94.71%, #73619E 100%)",
        ...sx,
      }}
    >
      {children}
    </Container>
  );
};
